
import React from 'react';
import { useDispatch } from 'react-redux';

import DialogConfirm from '../../common/client/components/DialogConfirm';

import projectGetActions from '../../sagas/project';

import DialogEditOperationItem from './DialogEditOperationItem';
import OperationItemView from './OperationItem.view';

const OperationItem = ({
    operation,
    operationItem,
    readOnly
}) => {

    const dispatch = useDispatch();
    const projectActions = projectGetActions(dispatch);

    const handleDeleteClick = async () => {
        let confirm = await DialogConfirm.show(`Opravdu chcete smazat položku ceníku "${operationItem.title}" ?`);
        if (confirm) {
            projectActions.deleteOperationItem(operationItem.id);
        }
    }

    const handleEditClick = async () => {
        let result = await DialogEditOperationItem.show(
            operation, operationItem.title, operationItem.price
        );
        if (result) {
            projectActions.updateOperationItem(
                operationItem.id, result.title, result.price
            )
        }
    }

    const getToolbarItems = () => {
        let items = [];

        if (!readOnly) {
            items.push({onClick: handleEditClick, title: 'Upravit'});
            items.push({onClick: handleDeleteClick, title: 'Smazat'});
        }

        return items;
    }

    return (
        <OperationItemView
            operationItem={operationItem}
            toolbarItems={getToolbarItems()}
        />
    );
}

export default OperationItem;
